import { DataGridComponent } from '@/ui/DataGrid/DataGridComponent'
import { Loading } from '@/ui/Loading'
import { ErrorComponent } from '@/ui/ErrorComponent'
import { TableColumnDefinition, createTableColumn } from '@fluentui/react-components'
import { ImageActionsMenu } from './ImageActionsMenu'
import { useListImages } from '@/hooks/useListImages'
import { MessagesSupportImageItem } from '@/dotnet-client'

type ImagesTableProps = {
  onAdd: () => void
  setRefetch: (refetch: () => void) => void
}

type DataGridColumnDefinitions = TableColumnDefinition<MessagesSupportImageItem>[]

export const ImagesTable = ({ onAdd, setRefetch }: ImagesTableProps) => {
  const { data: images, isLoading, isError, refetch } = useListImages()

  setRefetch(refetch)

  if (isLoading) return <Loading />
  if (isError || !images) return <ErrorComponent message="Error loading images." />
  if (images.length === 0) return <p>No images available.</p>

  // ✅ Fix the items mapping to handle optional properties
  const items = images.map((image) => ({
    filename: image.filename ?? '',
    imageKey: image.imageKey ?? '',
  }))

  const columns: DataGridColumnDefinitions = [
    createTableColumn({
      columnId: 'filename',
      renderHeaderCell: () => 'Filename',
      renderCell: (row) => row.filename,
    }),
    createTableColumn({
      columnId: 'actions',
      renderHeaderCell: () => (
        <th
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            paddingRight: '20px',
            fontWeight: 'bold',
            marginLeft: 'auto',
          }}
        >
          Actions
        </th>
      ),
      renderCell: (row) => (
        <td
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            paddingRight: '10px',
            fontWeight: 'bold',
            marginLeft: 'auto',
          }}
        >
          <ImageActionsMenu imageKey={row.filename ?? ''} onDelete={refetch} />
        </td>
      ),
    }),
  ]

  return <DataGridComponent items={items} columns={columns} onAdd={onAdd} />
}
